// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2MPBH","overflowing":"ReadFullNote_overflowing__3dYkg"};